import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SetProductBookingAmanoParkingReservation } from '@products/models/booking.model';
import { AmanaoParkingBookingService } from '@products/services/amano-parking-booking.service';
import { AmanoParkingBookingReservationActions } from '@store/products/booking/product/amano-parking/amano-parking-booking.actions';
import { AmanoParkingProductActions } from '@store/products/product.actions';
import { isEmpty } from 'lodash';
import { catchError, EMPTY, map, of, switchMap } from 'rxjs';

export const setAmanoParkingReservationDateInBooking$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(AmanoParkingProductActions.setAmanoParkingBookingReservation),
      switchMap(({ amanoParkingReservationDate }) => {
        if (isEmpty(amanoParkingReservationDate)) {
          return EMPTY;
        }

        return of(
          AmanoParkingBookingReservationActions.setAmanoParkingReservationDateInBooking({ amanoParkingReservationDate })
        );
      })
    ),
  { functional: true }
);

export const setValidatedAmanoParkingReservationDateInBooking$ = createEffect(
  (actions$ = inject(Actions), amanoParkingBookingService = inject(AmanaoParkingBookingService)) =>
    actions$.pipe(
      ofType(AmanoParkingBookingReservationActions.setAmanoParkingReservationDateInBooking),
      switchMap(({ amanoParkingReservationDate }) => {
        const { since, until } = amanoParkingReservationDate;

        if (!since || !until) {
          return EMPTY;
        }

        return amanoParkingBookingService.setAmanoParkingReservation$(amanoParkingReservationDate).pipe(
          switchMap((amanoParkingTariffReservationFee) => {
            return amanoParkingBookingService.getAmanoParkingTariffFee$(amanoParkingTariffReservationFee).pipe(
              map((response) => {
                const amanoParkingReservationPrice: number = response.body as number;
                const setProductBookingAmanoParkingReservation: SetProductBookingAmanoParkingReservation =
                  amanoParkingBookingService.mapAmanoParkingReservationTariffPriceResponseToSetProductBookingAmanoParkingReservation(
                    amanoParkingReservationDate,
                    amanoParkingReservationPrice,
                    true
                  );

                return AmanoParkingBookingReservationActions.setValidatedAmanoParkingReservationInBooking(
                  setProductBookingAmanoParkingReservation
                );
              }),
              catchError(() => {
                const setProductBookingAmanoParkingReservation: SetProductBookingAmanoParkingReservation =
                  amanoParkingBookingService.mapAmanoParkingReservationTariffPriceResponseToSetProductBookingAmanoParkingReservation(
                    amanoParkingReservationDate,
                    0,
                    false
                  );

                return of(
                  AmanoParkingBookingReservationActions.setValidatedAmanoParkingReservationInBooking(
                    setProductBookingAmanoParkingReservation
                  )
                );
              })
            );
          })
        );
      })
    ),
  { functional: true }
);
